export class ReservaPoupancaModel {

    constructor(
        public cdCentrus?: number,
        public dtBaseAtualizacao?: string,
        public dtBaseContribuicao?: string,
        public vlIndiceAtual?: number,
        public vlTotAtualizacao?: number,
        public vlTotContribAtualizada?: number,
        public vlTotContribuicao?: number,
        public vlTxAdministracao?: number,
        public dhRegistro?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/reserva-poupanca.model.ts